import { render, staticRenderFns } from "./RequestInvoiceForm.vue?vue&type=template&id=3d06db56&scoped=true"
import script from "./RequestInvoiceForm.vue?vue&type=script&lang=js"
export * from "./RequestInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./RequestInvoiceForm.vue?vue&type=style&index=0&id=3d06db56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06db56",
  null
  
)

export default component.exports